import axios from "axios";
import { useCallback, useEffect, useMemo, useReducer } from "react";
import { API } from "../../helpers";
import { initialState, reducer } from "./state";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import useUnit from "../../hooks/useUnit";
import useGlobalParams from "../../hooks/useGlobalParam";

export default function useController() {
  const { optionUnit, showOptionUnit } = useUnit();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { control, handleSubmit, getValues } = useForm();
  const defaultParam = useGlobalParams();

  const onSubmit = (data) => {
    fetchCashFlow();
  };

  const fetchAccount = useCallback(
    async (controller = new AbortController()) => {
      let unit = Cookies.get("fin_unit_data") ? Cookies.get("fin_unit_data") : "";
      let param = {
        request: "Coa Aktiva",
        unit_id: unit,
        ...defaultParam,
      };
      const account = await axios
        .post(`${API}/coa/cashflow`, JSON.stringify(param), {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => response?.data?.response_data)
        .catch(() => []);
      const accounts = account?.map((data) => {
        let label = `${data.code} - ${data.name}`;
        const newData = { label, value: data.code?.toString() };
        return newData;
      });
      dispatch({ type: "accounts", accounts });
    },
    [dispatch]
  );

  const fetchCashFlow = useCallback(
    (controller = new AbortController()) => {
      let unitDefault = Cookies.get("fin_unit_data") ? Cookies.get("fin_unit_data") : "";
      let unit;
      let data = getValues();
      unit = data.unit?.value;
      if (!unit) {
        unit = unitDefault;
      }
      let param = {
        request: "Dashboard Cash Flow",
        unit_id: unit,
        ...defaultParam,
      };
      if (data.account?.length > 0) {
        let account = data.account?.map((datax) => datax.value);
        param.account = account;
      }
      axios
        .post(`${API}/dashboard/cash-flow`, JSON.stringify(param), {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let dataLine = response?.data?.response_data;
          dispatch({ type: "dataLine", dataLine });
        })
        .catch((err) => {
          if (err?.message !== "canceled") {
            console.log(err);
          }
          dispatch({
            type: "dataLine",
            dataLine: {
              labels: diff(
                new Date(new Date().getFullYear(), 0, 1),
                new Date(new Date().getFullYear(), 11, 31)
              ),
              datasets: [],
            },
          });
        });
    },
    [diff, dispatch]
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
  };

  useMemo(() => {
    document.title = "Beranda";
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchCashFlow(controller);
    fetchAccount(controller);
    return () => {
      controller.abort();
    };
  }, []);

  return {
    state,
    options,
    handleSubmit,
    onSubmit,
    control,
    optionUnit,
    showOptionUnit,
  };
}

function diff(from, to) {
  var arr = [];
  var datFrom = from;
  var datTo = to;
  var fromYear = datFrom.getFullYear();
  var toYear = datTo.getFullYear();
  var diffYear = 12 * (toYear - fromYear) + datTo.getMonth();

  for (var i = datFrom.getMonth(); i <= diffYear; i++) {
    let month = parseInt((i % 12) + 1);
    arr.push(Math.floor(fromYear + i / 12) + "-" + (month < 10 ? "0" + month : month));
  }
  return arr;
}
